// src/components/Routee/RouteeModal.jsx
import React, { useEffect, useState } from 'react';
import { alertNotification } from '../../utils/notification';

const RouteeModal = ({ isOpen, onClose, onSave, isSaving }) => {
  const MAX_ITEMS = 5;

  const [routeeName, setRouteeName] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [routees, setRoutees] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setRoutees([]);
      setRouteeName('');
      setIsActive(true);
    }
  }, [isOpen]);

  const addRow = () => {
    if (!routeeName.trim()) {
      alert('Route name is required');
      return;
    }

    if (routees.length >= MAX_ITEMS) {
      alert('Maximum 5 routes allowed');
      return;
    }

    const exists = routees.some(
      (r) => r.name.toLowerCase() === routeeName.trim().toLowerCase()
    );

    if (exists) {
      alertNotification('Route already exists', 'error');
      return;
    }

    setRoutees((prev) => [...prev, { name: routeeName.trim(), isActive }]);
    setRouteeName('');
    setIsActive(true);
  };

  const removeRow = (index) => {
    setRoutees((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (routees.length === 0) {
      alert('Please add at least one route');
      return;
    }

    // EXACT payload:
    // { routes: [ { name, isActive }, ... ] }
    onSave({ routes: routees });
  };

  const handleClose = () => {
    if (!isSaving) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="inventory-modal-overlay">
      <div className="inventory-modal-content">
        <header className="inventory-modal-header">
          <h3 className="inventory-modal-title">Add New Routes</h3>
          <button
            className="inventory-close-modal-btn"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            ×
          </button>
        </header>

        <div className="inventory-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="inventory-form-grid">
              <label>
                Route Name <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                className="inventory-custom-input"
                value={routeeName}
                onChange={(e) => setRouteeName(e.target.value)}
                disabled={isSaving}
                placeholder="e.g., L-01"
              />

              <label>Active</label>
              <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                disabled={isSaving}
              />
               </div>
              <button
                type="button"
                className="inventory-btn inventory-btn-action inventory-btn-edit"
                onClick={addRow}
                disabled={routees.length >= MAX_ITEMS || isSaving}
              style={{ marginLeft: 'auto', display: 'block' }}
              >
               ➕ Add
              </button>
           

            <table className="inventory-data-table" style={{ marginTop: 16 }}>
              <thead>
                <tr>
                  <th>Route Name</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {routees.length === 0 ? (
                  <tr>
                    <td colSpan="3">No data</td>
                  </tr>
                ) : (
                  routees.map((r, index) => (
                    <tr key={index}>
                      <td>{r.name}</td>
                      <td>{r.isActive ? 'Active' : 'Inactive'}</td>
                      <td>
                        <button
                          type="button"
                          onClick={() => removeRow(index)}
                          disabled={isSaving}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </form>
        </div>

        <footer className="inventory-modal-footer">
          <button
            className="inventory-btn inventory-btn-cancel"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            Cancel
          </button>
          <button
            className="inventory-btn inventory-btn-save"
            onClick={handleSubmit}
            disabled={isSaving}
            type="button"
          >
            {isSaving ? 'Saving...' : 'Save Routes'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default RouteeModal;
